

<div *ngIf="isloading; else loadedBox" class="w-100 t-a-center">
  Завантаження...
</div>

<ng-template #loadedBox>

<div *ngIf="model.length > 0; else emptyBox" #qsContainer class="w-100 h-250px overf-h">

    <div *ngIf="sizes.isWider" class="fl-l w-35px">
      <button kendoButton 
        icon="arrow-chevron-left" 
        [disabled]="sizes.btnsQueuesScrollLeft == 0" 
        (click)="move('back')" 
        class="pos-sticky t-0">
      </button>
    </div>

    <div #qsScrollable class="fl-l overf-h" [style.height.px]="sizes.btnsQueuesHeight" [style.width.px]="sizes.btnsQueuesWidth">
      <div class="fl-l overf-auto" [style.height.px]="sizes.qsContainerHight" [style.width.px]="sizes.evaluatedWidth + 20">

        <div class="fl-l pos-sticky t-0" style="z-index: 1;background-color: #eee;" 
          [style.width.px]="sizes.evaluatedWidth">
          <div *ngFor="let day of model" class="schedule-top-cell">
            {{ day.dayOfWeek }} <br />
            {{ day.date  | date : 'dd,' }} {{ day.monthGenShort }}
          </div>
        </div>

        <div class="fl-l" [style.width.px]="sizes.evaluatedWidth">
          <div *ngFor="let x of model" class="fl-l w-110px t-a-center">
            <button *ngFor="let xx of x.apps" kendoButton fillMode="outline"
              class="w-95px h-25px m-5 bg-c-E7EBEE"
              (click)="queueSelected.emit(xx)"
            > 
              {{ xx.timeBegin }} 
            </button>
            <br /><br />
          </div>
        </div>

      </div>
    </div>

    <div *ngIf="sizes.isWider" class="fl-l w-30px p-l-5">
      <button kendoButton 
        icon="arrow-chevron-right" 
        [disabled]="sizes.btnsQueuesScrollLeft == sizes.maxOffset"  
        (click)="move('forward')" 
        class="pos-sticky t-0">
      </button>
    </div>
</div>

<ng-template #emptyBox>
  <div class="w-100 t-a-center">
    На даний напрямок прийоми відсутні. Оберіть інший напрямок.
  </div>
</ng-template>

</ng-template>
